export const getYDomainMax = (dataMax : number) : number => {
    return dataMax + Math.floor(0.1*dataMax) + 1
}